import type {CoreCoachProgramsListParams} from '../../../api/types/core/methods';

import {apiRequest} from '../../../api/utils/apiRequest';
import {slugify} from '../../format';

// TODO: should use request from services?
export const getUniqueProgramSlug = async (title: string, userId: string) => {
  let slug = slugify(title, '-');

  const programs = await apiRequest<CoreCoachProgramsListParams>({
    method: 'coach.programs.list',
    params: {
      query: [
        ['user_id', '==', userId],
        ['slug', '==', slug],
      ],
    },
  });

  if (programs._items.length) {
    slug = `${slug}-${programs._items.length}`;
  }

  return slug;
};
